import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { enumValidator, PartnerOrganizationType } from '#validation';
import { createListQuery } from '#web-service-api/common';
import { PartnerOrganizationResponseSchema } from '../response';
export const PartnerOrganizationListQuery = createListQuery({
    schema: PartnerOrganizationResponseSchema,
    sortable: {
        by: ['name'],
        default: 'name',
    },
    pageSize: {
        default: 10,
        max: 100,
    },
    filters: z.object({
        type: enumValidator({
            values: PartnerOrganizationType,
            invalidValueError: 'partnerOrganization.type.invalid',
        }).exactOptional(),
        name: z.string().min(1).exactOptional(),
    }),
});
export class PartnerOrganizationListQueryDto extends createZodDto(PartnerOrganizationListQuery.codec) {
}
